import api from './api';

export interface EmailSettings {
  email_cc_recipients: string;
  weekly_pending_report_recipients?: string;
}

export interface CalendarSettings {
  calendar_users: string[];
  availability_mode: 'any' | 'all';
}

export const getEmailSettings = () =>
  api.get<EmailSettings>('/settings/email');

export const updateEmailSettings = (data: EmailSettings) =>
  api.put<EmailSettings & { message: string }>('/settings/email', data);

export const sendPendingCasesReport = () =>
  api.post<{ message: string }>('/settings/pending-report/send');

export const getCalendarSettings = () =>
  api.get<CalendarSettings>('/settings/calendar');

export const updateCalendarSettings = (data: CalendarSettings) =>
  api.put<CalendarSettings & { message: string }>('/settings/calendar', data);

const settingsService = {
  getEmailSettings,
  updateEmailSettings,
  sendPendingCasesReport,
  getCalendarSettings,
  updateCalendarSettings,
};

export default settingsService;
